import request from '../request'

// 简单的内存缓存机制
const cache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5分钟缓存时间

// 缓存工具函数
const getCacheKey = (url, params) => {
  return `${url}_${JSON.stringify(params || {})}`;
};

const isValidCache = (cacheItem) => {
  return cacheItem && (Date.now() - cacheItem.timestamp) < CACHE_DURATION;
};

export const articleApi = {
    getList(params) {
      return request({
        url: '/cms/article/list',
        method: 'get',
        params: {
          columnId: params.columnId,
          articleType:params.articleType,
        }
      });
    },
    getcarouselImage(params) {
      return request({
        url: '/cms/carouselImage/list',
        method: 'get',
        params,
      });
    },
    getListDetails(articleId) {
        const cacheKey = getCacheKey(`/cms/article/${articleId}`);
        const cachedData = cache.get(cacheKey);
        
        // 检查缓存是否有效
        if (isValidCache(cachedData)) {
          console.log(`[API Cache] 使用缓存数据获取文章详情: ${articleId}`);
          return Promise.resolve(cachedData.data);
        }
        
        console.log(`[API Cache] 发起新的API请求获取文章详情: ${articleId}`);
        return request({
          url: `/cms/article/${articleId}`,
          method: 'get',
        }).then(response => {
          // 缓存响应数据
          cache.set(cacheKey, {
            data: response,
            timestamp: Date.now()
          });
          console.log(`[API Cache] 已缓存文章详情数据: ${articleId}`);
          return response;
        });
      },
      userConsultations(data) {
        return request({
          url: '/cms/userConsultations',
          method: 'post',
          data,
        });
      },
      getmenu() {
        return request({
          url: '/cms/CmsColumn/getCmsRouters',
          method: 'get',
        });
      }
  };


  